// extracted by mini-css-extract-plugin
module.exports = {"addresses":"PreviousAddresses_addresses__2Gwjt","address":"PreviousAddresses_address__3OOtN"};